import { TCollection, TEntity, TEntityRef, TNote } from '@ws/shared/types';
import { useContext } from 'react';

import { EditabilityContext } from '../../../context/EditabilityContext';
import { ContentBoardContainer } from '../ContentBoardContainer';
import { WriteBoardContainer } from '../WriteBoardContainer';

import styles from './BoardManager.module.css';
import { NoteStats } from '../../../components/Editor/NoteStats';
import { BoardManagerCtxProvider, EBoardType } from '../../../context/BoardManagerContext/context';

interface IBoardManagerProps {
  entityRef: TEntityRef;
  isCompiled: boolean;
  board: EBoardType;
}

export function BoardManager({ entityRef, isCompiled, board }: IBoardManagerProps) {
  const editability = useContext(EditabilityContext);
  const entity = { ...editability.getNodeByRef(entityRef) } as TEntity;

  return (
    <BoardManagerCtxProvider value={{ board: board }}>
      <div className={styles['board-wrapper']}>
        <div style={{ width: '100%', overflow: 'auto' }}>
          {entity.type === 'note' ? (
            <>
              <WriteBoardContainer note={entity as TNote} />
            </>
          ) : (
            <ContentBoardContainer isCompiled={isCompiled} entity={entity as TCollection} />
          )}
        </div>
        <NoteStats entityId={entity.id} />
      </div>
    </BoardManagerCtxProvider>
  );
}
